const ShowDocumentImage = ({document}) => (
  <img style={{maxWidth: '100%', height: 'auto'}} src={document.src} alt={document.label}/>
);
export default ShowDocumentImage;
